import { format, getTime, formatDistanceToNow } from 'date-fns';
import dayjs from 'dayjs';
import moment from 'moment-timezone';

// ----------------------------------------------------------------------

export function fDate(date) {
  if (!date) return '';
  return format(new Date(date), 'dd MMMM yyyy');
}

export function fDateId(date) {
  if (!date) return '';
  return format(new Date(date), 'ddMMyy');
}

export function fDate2(date) {
  if (!date) return '';
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fTimeZones(dateTime) {
  return moment(dateTime).tz('Asia/Singapore').format('YYYY-MM-DDTHH:mm:ss');
}

export function fDateTime(date) {
  if (!date) return '';
  return format(new Date(date), 'dd MMM yyyy hh:mm:ss a');
}

export function fDateTimeFix(date) {
  if (!date) return '';
  const oneHour = 60 * 60 * 1000;
  const newDate = new Date(date);

  return format(new Date(newDate.getTime() + oneHour), 'dd MMM yyyy hh:mm:ss a');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  if (!date) return '';
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

export function fDateTime2(date) {
  if (!date) return '';
  return dayjs(date).format('YYYY-MM-DDTHH:mm:ss');
}